import React, { FC } from "react";
import { Outlet } from "react-router-dom";

interface GlobalLayout {}

const GlobalLayout: FC<GlobalLayout> = () => <Outlet />;

export default GlobalLayout;
